import React, {
  createContext, useContext, useMemo, useState
} from 'react';
import PropTypes from 'prop-types';
import createAppTheme from 'src/theme';

const STORAGE_KEY = 'themeMode';

const ThemeModeContext = createContext({
  mode: 'light',
  toggleMode: () => {}
});

export const ThemeModeProvider = ({ children }) => {
  const [mode, setMode] = useState(
    () => window.localStorage.getItem(STORAGE_KEY) || 'light'
  );

  const toggleMode = () => {
    setMode((prevMode) => {
      const nextMode = prevMode === 'light' ? 'dark' : 'light';
      window.localStorage.setItem(STORAGE_KEY, nextMode);
      return nextMode;
    });
  };

  const theme = useMemo(() => createAppTheme(mode), [mode]);

  const value = useMemo(() => ({ mode, toggleMode, theme }), [mode, theme]);

  return (
    <ThemeModeContext.Provider value={value}>
      {children}
    </ThemeModeContext.Provider>
  );
};

ThemeModeProvider.propTypes = {
  children: PropTypes.node
};

export const useThemeMode = () => useContext(ThemeModeContext);

export default ThemeModeContext;
